<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/dashboard">
      <img class="logo-fif" src="../assets/images/indocyber-logo.png" alt="">
      <img class="logo-fif-minimized" src="../assets/images/indocyber-logo.png" alt="">
    </CSidebarBrand>
    <CSidebarNav>
      <CSidebarNavItem
        icon="cil-home"
        name="Dashboard"
        v-if="$helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['Cabang']) || $helper.isRole($availRoles['Notaris'])"
         :to="{
            name:'Dashboard',
            params: {
              
            }
          }"
      ></CSidebarNavItem>
      <!-- <CSidebarNavItem
        v-if="$helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['Cabang']) || $helper.isRole($availRoles['Notaris'])"
      >
        <CLink
          class="c-sidebar-nav-link"   
          to="/dashboard"
          :exact="true"
          activeClassName="c-active"
        >
          <img class="custom-icon-sidebar" src="../assets/images/add.png" /><span class="ml-4">Home</span>
        </CLink>
      </CSidebarNavItem> -->
      <CSidebarNavItem
        icon="cil-book"
        name="Fiducia"
        v-if="$helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['Cabang']) || $helper.isRole($availRoles['Notaris'])"
         :to="{
            name:'Fiducia List',
            params: {
              
            }
          }"
      ></CSidebarNavItem>
      <CSidebarNavItem
        icon="cil-pen-alt"
        name="Roya"
        v-if="$helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['Cabang']) || $helper.isRole($availRoles['Notaris'])"
         :to="{
            name:'Roya List',
            params: {
              
            }
          }"
      ></CSidebarNavItem>
      <CSidebarNavDropdown
        icon="cil-file"
        name="APHT"
        v-if="$helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['Cabang'])"
      >
        <CSidebarNavItem
          name="Created"
          :to="{ name:'APHT List Created' }"
          v-if="$helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['Cabang'])"
        ></CSidebarNavItem>
        <CSidebarNavItem
          name="Need Approval"
          :to="{ name:'APHT List Need Approval' }"
          v-if="$helper.isRole($availRoles['Cabang'])"
        ></CSidebarNavItem>
      </CSidebarNavDropdown>
      <CSidebarNavDropdown
        icon="cil-check-circle"
        name="Validasi"
        v-if="$helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['Cabang'])"
      >
        <CSidebarNavItem
          name="Fiducia"
          :to="{ name:'Validation Fiducia List' }"
        ></CSidebarNavItem>
        <CSidebarNavItem
          name="Roya"
          :to="{ name:'Validation Roya List' }"
        ></CSidebarNavItem>
      </CSidebarNavDropdown>
      <CSidebarNavDropdown
        name="Payment Fiducia"
        icon="cil-credit-card"
        v-if="$helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['Cabang']) || $helper.isRole($availRoles['Notaris'])"
      >
        <CSidebarNavItem
          name="All"
          :to="{name: 'Invoice Fiducia List'}"
        ></CSidebarNavItem>
        <CSidebarNavItem
          name="Paid"
          :to="{name: 'Invoice Paid Fiducia List'}"
        ></CSidebarNavItem>
      </CSidebarNavDropdown>
      <CSidebarNavDropdown
        name="Payment Roya"
        icon="cil-credit-card"
        v-if="$helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['Cabang']) || $helper.isRole($availRoles['Notaris'])"
      >
        <CSidebarNavItem
          name="All"
          :to="{name: 'Invoice Roya List'}"
        ></CSidebarNavItem>
        <CSidebarNavItem
          name="Paid"
          :to="{name: 'Invoice Paid Roya List'}"
        ></CSidebarNavItem>
      </CSidebarNavDropdown>
      <CSidebarNavDropdown
        name="Payment APHT"
        icon="cil-credit-card"
        v-if="$helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['Cabang'])"
      >
        <CSidebarNavItem
          name="Created"
          :to="{name: 'Invoice APHT Approved List'}"
        ></CSidebarNavItem>
        <CSidebarNavItem
          name="Need Approval"
          :to="{name: 'Invoice APHT List'}"
          v-if="$helper.isRole($availRoles['Cabang'])"
        ></CSidebarNavItem>
      </CSidebarNavDropdown>
      <CSidebarNavItem
        icon="cil-balance-scale"
        name="Notaris"
        v-if="$helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['FIMS'])"
         :to="{
            name:'Notaris List',
            params: {
              
            }
          }"
      ></CSidebarNavItem>
      <CSidebarNavItem
        icon="cil-user"
        name="User"
        v-if="$helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['FIMS'])"
         :to="{
            name:'User List',
            params: {
              
            }
          }"
      ></CSidebarNavItem>
      <CSidebarNavDropdown
        name="System Configuration"
        icon="cil-settings"
        v-if="$helper.isRole($availRoles['HO'])"
      >
        <CSidebarNavItem
          name="Parameter"
          :to="{name: 'Config Parameter List'}"
        ></CSidebarNavItem>
        <CSidebarNavItem
          name="Script"
          :to="{name: 'Config Script List'}"
        ></CSidebarNavItem>
        <CSidebarNavItem
          name="Dokumen"
          :to="{name: 'Config Document List'}"
        ></CSidebarNavItem>
        <CSidebarNavItem
          name="Principal"
          :to="{name: 'Config Principal List'}"
        ></CSidebarNavItem>
        <CSidebarNavItem
          name="Scheduler"
          :to="{name: 'Config Scheduler List'}"
        ></CSidebarNavItem>
        <CSidebarNavItem
          name="Role"
          :to="{name: 'Config Role List'}"
        ></CSidebarNavItem>
        <CSidebarNavItem
          name="Payment Status"
          :to="{name: 'Config Payment Status'}"
        ></CSidebarNavItem>
        <CSidebarNavItem
          name="Assignment Roya"
          :to="{name: 'Config Assignment Roya'}"
        ></CSidebarNavItem>
        <CSidebarNavItem
          name="Approval Berjenjang"
          :to="{name: 'Config Approval List', params: { by: 'office-type'}}"
          v-if="$helper.isRole($availRoles['HO'])"
        ></CSidebarNavItem>
      </CSidebarNavDropdown>
      <!-- <CSidebarNavDropdown
        name="Logs"
        icon="cil-clipboard"
        v-if="$helper.isRole($availRoles['HO'])"
      >
        <CSidebarNavItem
          name="Server"
          :to="{name: 'Logs Server List'}"
        ></CSidebarNavItem>
        <CSidebarNavItem
          name="Security"
          :to="{name: 'Logs Security List'}"
        ></CSidebarNavItem>
        <CSidebarNavItem
          name="Transaction"
          :to="{name: 'Logs Transaction List'}"
        ></CSidebarNavItem>
      </CSidebarNavDropdown> -->
      <!--<CSidebarNavItem
        icon="cil-account-logout"
        name="Logout"
        :to="{}"
        @click.native="showLogoutModal = true"
      ></CSidebarNavItem>
      <CSidebarNavDropdown
        name="Document Assignment"
        icon="cilClipboard"
      >
        <CSidebarNavItem
          name="Set Document Reminder"
          :to="{
            name:'DocumentAssignment',
            params: {
              actionType: 'SetDocumentReminder'
            }
          }"
        />
        <CSidebarNavItem
          name="Document Management"
          :to="{
            name:'DocumentAssignment',
            params: {
              actionType: 'ManageDocument'
            }
          }"
        />
      </CSidebarNavDropdown>
      <CSidebarNavItem
        icon="cilAvTimer"
        name="SLA Assignment"
         :to="{
            name:'DocumentAssignment',
            params: {
              actionType: 'setSLA'
            }
          }"
      ></CSidebarNavItem>
      <CSidebarNavItem
        icon="cilInstitution"
        name="Toggle SIAP Offices"
        :to="{name: 'ToggleISSOffice'}"
      >
      </CSidebarNavItem>
      <CSidebarNavItem
        icon="cilListNumbered"
        name="Daftar Antrian"
        :to="{name: 'Reporting',
          params: {
            reportType: 'listQueueInfo'
          }
        }"
      ></CSidebarNavItem>
      <CSidebarNavItem
        icon="cilQrCode"
        name="Daftar Antrian FMC"
        :to="{name: 'Reporting',
          params: {
            reportType: 'listQueueFMCInfo'
          }
        }"
      ></CSidebarNavItem>
      <CSidebarNavItem
        icon="cilAlarm"
        name="Daftar Antrian Diatas SLA"
        :to="{name: 'Reporting',
          params: {
            reportType: 'listAboveSLAQueueInfo'
          }
        }"
      ></CSidebarNavItem>
      <CSidebarNavItem
        icon="cilScreenSmartphone"
        name="Daftar Counter Astrapay"
        :to="{name: 'Reporting',
          params: {
            reportType: 'listAstrapayCount'
          }
        }"
      ></CSidebarNavItem>
      <CSidebarNavItem
        icon="cilChatBubble"
        name="Daftar Komplain"
        :to="{name: 'Reporting',
          params: {
            reportType: 'listComplaintQueueInfo'
          }
        }"
      ></CSidebarNavItem>
      <CSidebarNavItem
        icon="cilStar"
        name="Rating Tiap Antrian"
        :to="{name: 'Reporting',
          params: {
            reportType: 'listRateByQueueInfo'
          }
        }"
      ></CSidebarNavItem>
      <CSidebarNavItem
        icon="cilBadge"
        name="Rating Rata-Rata Frontliner"
        :to="{name: 'Reporting',
          params: {
            reportType: 'listAverageRateByUserInfo'
          }
        }"
      ></CSidebarNavItem>
      <CSidebarNavItem
        icon="cilListNumbered"
        name="Daftar Antrian Di Transfer"
        :to="{name: 'Reporting',
          params: {
            reportType: 'listTicketTransferred'
          }
        }"
      ></CSidebarNavItem>
      <CSidebarNavItem
        icon="cilFindInPage"
        name="Detail Antrian"
        :to="{name: 'QueueDetail'}"
      ></CSidebarNavItem>
      <CSidebarNavItem
        icon="cilTransfer"
        name="Transfer Reason"
        :to="{name: 'DaftarReason', params: { header: 'transferReason'}}"
      ></CSidebarNavItem>
      <CSidebarNavItem
        icon="cilTags"
        name="Kategori End Service Reason"
        :to="{name: 'DaftarReason', params: { header: 'frontlinerEndServiceReasonCategory'}}"
      ></CSidebarNavItem>
      <CSidebarNavItem
        icon="cilPeople"
        name="User Management"
        :to="{name: 'Reporting',
          params: {
            reportType: 'listLocalUser'
          }
        }"
      ></CSidebarNavItem>
      <CSidebarMinimizer
        class="d-md-down-none"
        @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
      />-->
    </CSidebarNav>
    <CModal
      :closeOnBackdrop="false" 
      color="primary"
      :show.sync="showErrorModal" :centered="true">
      <div slot="header"><h5>{{modalTitle}}</h5></div>
      <div class="">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>
    <!-- <CModal color="primary"
      :show.sync="showLogoutModal" :centered="true" :closeOnBackdrop="false">
      <div slot="header"><h5>Logout</h5></div>
      <div>
        Anda yakin ingin logout ?
      </div>
      <div slot="footer">
        <CButton size="lg" class="mr-2" color="danger" @click="showLogoutModal = false">Batal</CButton>
        <CButton size="lg" class="mr-2" color="primary" @click="logout()">OK</CButton>
      </div>
    </CModal> -->
    <CModal
      color="primary"
      :show.sync="showNoticeModal" :centered="true" :closeOnBackdrop="false">
      <div slot="header"><h5>{{notifObject.type}}</h5></div>
      <div class="">
        Anda mendapatkan notifikasi baru mengenai <strong>{{notifObject.purpose}}</strong>
      </div>
      <div slot="footer">
        <CButton size="lg" class="mx-3" color="primary" @click="refreshAction(itemChoosen)">OK</CButton>
      </div>
    </CModal>
  </CSidebar>
</template>

<script>
// import SockJS from "sockjs-client";
// import Stomp from "webstomp-client";
export default {
  name: 'TheSidebar',
  data(){
    return {
      modalTitle: 'Error',
      errorLabel: 'System Error',
      showErrorModal: false,
      showNoticeModal: false,
      showLogoutModal: false,
      notifObject: {},
      connected: false,
      itemChoosen: {}
    }
  },
  methods: {
    //----------Batas Awal Fungsi Websocket----------------
    connect() {
      // if(!this.connected) {
      //   this.socket = new SockJS(this.$axios.defaults.baseURL+"fif-iss-websocket");
      //   this.stompClient = Stomp.over(this.socket);
      //   this.stompClient.connect({},
      //     frame => {
      //       this.connected = true;
      //       // console.log(frame);
      //       this.stompClient.subscribe("/ws-spv/"+sessionStorage.getItem("loginId"), tick => {
      //         let a = JSON.parse(tick.body);
      //         // console.log(a)
      //         if(a){
      //           this.notifObject = a;
      //           this.showNoticeModal = true;
      //         }
      //         // if(a.type == "RATING-NOTIFICATION") {
      //         //   //ada yg kasi rating <= 2 -> TOAST / MODAL
      //         // } else if (a.type == "NEED-HELP-NOTIFICATION") {
      //         //   //ada yg butuh bantuan -> TOAST / MODAL
      //         // }
      //       });
      //     },
      //     error => {
      //       // console.log(error);
      //       this.connected = false;
      //       // this.tickleConnection();
      //     }
      //   );
      // }
    },
    disconnect() {
      // if (this.stompClient) {
      //   this.stompClient.disconnect();
      // }
      // this.connected = false;
    },
    tickleConnection() {
      // this.connected ? this.disconnect() : this.connect();
    },

    // ------------Batas Akhir websocket-------------------

    action(item){
      // this.itemChoosen = item;
      // if(item.action != '-'){
      //   if(item.action == 'logout'){
      //     this.showLogoutModal = true;
      //   }
      //   else {
      //     this.$router.push({name: item.url});
      //   }
      // } else {
      //   return null
      // }
    },
    // action ketika ada notif masuk dari websocket
    refreshAction(item){
      // //if (this.$route.name == 'Dashboard'){
      // //  this.goToDashboard();
      // //} else {
      //   this.action(item)
      // //}
    },
    // logout(){
    //   localStorage.removeItem(this.$tokenKeyword);
    //   localStorage.removeItem(this.$tokenClockKeyword);
    //   localStorage.removeItem(this.$userIdKeyword);
    //   localStorage.removeItem(this.$userNameKeyword);
    //   localStorage.removeItem(this.$roleIdKeyword);
    //   // localStorage.removeItem(this.$roleNameKeyword);
    //   this.$router.push({ name: 'Login' })
    //   // if(this.isLoggedIn){
    //   //   this.$store.commit('set', ['isLoading', true]);
    //   //   let data = new FormData();
    //   //   data.set('loginId', sessionStorage.getItem('loginId'));
    //   //   let processUrl = "/frontliner/logoutAsRoleAndOffice";
    //   //   this.$axios.post(processUrl, data)
    //   //   .then((response) => {
    //   //     this.showLogoutModal = false;
    //   //     if(response.status == 200){
    //   //       this.$store.commit('set', ['isLoading', false]);
    //   //       this.$router.push({ name: 'Login' }).catch((err) => {});
    //   //     } else {
    //   //       this.$router.push({ name: 'Login' });
    //   //     }
    //   //   })
    //   //   .catch((error) => {
    //   //     this.showLogoutModal = false;
    //   //     this.$router.push({ name: 'Login' });
    //   //   })
    //   // } else {
    //   //   return this.$router.push({ name: 'Login' }).catch((err) => {});
    //   // }
    // },
    errorAction(error){
      let listError = this.$helper.errorHandling(error);
      this.modalTitle = this.$errorLabel.generic;
      this.errorLabel = 'Terjadi kesalahan: '+listError[0] || 'Unknown Error';
      this.$store.commit('set', ['isLoading', false]);
      this.showErrorModal = true;
    }
  },
  computed: {
    show () {
      return this.$store.state.sidebarShow
    },
    minimize () {
      return this.$store.state.sidebarMinimize
    },
    isLoggedIn(){
      if(localStorage.getItem('token')){
        return true;
      } else { return false }
    }
  },
  created(){
    //let _this = this;
    //this.connect();
    //setInterval(function() {
    //  if(!_this.connected) {
    //    _this.connect()
    //  }
    //}, 2000);
  }

}
</script>

<style>

</style>
